import * as S from '@effect/schema/Schema'

import { StudentDomain } from '~/@entities/Student/domain.ts'

import { ContentLevel } from './(Content)/module'

// TODO: 정리하려면 시간 걸리니 일단 스키마를 이 파일에 다 때려넣고 나중에 정리하자
export module CommonDomain {
  export const STATUS = {
    INCOMPLETE: 'INCOMPLETE',
    COMPLETE: 'COMPLETE',
    PROGRESS: 'PROGRESS',
  } as const

  export const Video = S.struct({
    id: S.number,
    thumbnailUrl: S.string,
    // thumbnailUrl: S.string.pipe(S.nullable),

    videoUrl: S.string,
  })

  export const Status = S.enums(STATUS)
  export type Status = S.Schema.To<typeof Status>
}
export module AnswerDomain {
  export const Unit = S.struct({
    unit: S.string,
    index: S.number,
  })
}

// 문제 도메인
export module ProblemDomain {
  export const TYPE = {
    단답형: 'SINGLE_CHOICE',
    선다형: 'MULTIPLE_CHOICE',
    주관식: 'SHORT_ANSWER',
    서술형: 'ESSAY',
  } as const

  export const AUTO_SCORED_TYPE = {
    불가능: 'IMPOSSIBLE',
    가능_0포함양수: 'POSSIBLE_PLUS',
    가능_음수: 'POSSIBLE_MINUS',
    가능_단위: 'POSSIBLE_UNIT',
    가능_분수: 'POSSIBLE_FRACTION',
    가능_소수: 'POSSIBLE_DECIMAL',
    가능_연산필요분수: 'CALCULATION_FRACTION',
    미확인: 'UNIDENTIFIED',
    가능_영어한글문자열: 'POSSIBLE_TEXT',
  } as const

  export const GROUP_CASE = {
    SUB_TOPIC: 'SUB_TOPIC',
    CONCEPT: 'CONCEPT',
    TOPIC: 'TOPIC',
    SUB_TOPIC_SPECIAL: 'SUB_TOPIC_SPECIAL',
  } as const

  export const SCORING_RESULT = {
    정답: 'CORRECT',
    오답: 'WRONG',
    모름: 'UNKNOWN',
    안품: 'NONE',
    비공개: 'RESTRICTED',
  } as const

  export const KEYPAD_TYPES = {
    DECIMAL: 'DECIMAL',
    FRACTION: 'FRACTION',
    MIXED_FRACTION: 'MIXED_FRACTION',
    TEXT: 'TEXT',
  } as const

  export const TAG_TOP_TYPE = {
    twin: '[쌍둥이]',
    similar: '[유사]',
    wrong: '[틀린 문제]',
    same: '[동일]',
  }

  // CustomWorkbook이 아닌 교재의 문제의 경우 저작권 이슈로 인해 ProblemId가 null일 수 있음.
  // 이 경우 workbookProblemId를 통해 해당 문제를 특정하고 정보만 가져와서 사용함.
  // 시중교재, 교과서가 아닌 경우 null이 안나옴.
  export const IdInTheWorkbook = S.nullable(S.number)

  export const ScoringResult = S.enums(SCORING_RESULT)
  export type ScoringResult = S.Schema.To<typeof ScoringResult>

  export const Type = S.enums(TYPE)
  export type Type = S.Schema.To<typeof Type>

  export const AutoScoredType = S.enums(AUTO_SCORED_TYPE)
  export const groupCase = S.enums(GROUP_CASE)
  export const KeypadTypes = S.enums(KEYPAD_TYPES)

  export const Problem = S.struct({
    id: S.number,
    type: Type,
    conceptId: S.number,
    groupCode: S.number.pipe(S.nullable),
    topicId: S.number.pipe(S.nullable),
    subTopicId: S.number.pipe(S.nullable),
    groupCase: groupCase.pipe(S.nullable),
    optionCount: S.number,
    level: ContentLevel,
    problemImageUrl: S.string,
    answerImageUrl: S.string,
    solutionImageUrl: S.string,
    answer: S.string,
    answerCount: S.number,
    answerUnits: S.array(AnswerDomain.Unit),
    autoScoredType: AutoScoredType,
    autoScored: S.boolean,
    hidden: S.boolean,
    trendy: S.boolean,
    keypadTypes: S.array(KeypadTypes),
    levelOfConceptChip: S.any,
    videoMatched: S.optional(S.boolean),
  })

  export type Problem = S.Schema.To<typeof Problem>

  export const Summary = S.struct({
    problemId: S.number,
    totalUsed: S.number,
    correctTimes: S.number,
    wrongTimes: S.number,
    answerRate: S.number,
  })
}

// 자기주도학습
export module LearningProcessDomain {
  export const Problem = S.extend(
    ProblemDomain.Problem,
    S.struct({
      problemSummary: ProblemDomain.Summary,
      video: CommonDomain.Video.pipe(S.nullable),
    }),
  )

  export const AssignedWorksheet = S.struct({
    studentWorksheetId: S.number,
    studentName: S.string,
    studentId: StudentDomain.Id,
    status: CommonDomain.Status,
  })

  export const Scoring = S.struct({
    studentWorksheetScoring: S.struct({
      worksheetProblemId: S.number,
      result: ProblemDomain.ScoringResult,
      userAnswer: S.string.pipe(S.nullable),
    }),
    worksheetProblem: S.struct({
      index: S.number,
      tagTop: S.string,
    }),
    problem: Problem,
  })
}

export module WorksheetDomain {
  export const SELF_LEARNING_TYPE = {
    심화학습: 'LEVEL_UP',
    오답유형학습: 'WRONG_CONCEPT',
  } as const

  export const TYPE = {
    CUSTOM: 'CUSTOM',
    내신대비추천: 'RECOMMEND',
    모의고사: 'PRACTICE_TEST',
    연산: 'ARITHMETIC',
    입학테스트: 'ENTRANCE',
    WEEKLY: 'WEEKLY',
    단원테스트: 'CHAPTER',
    내신대비교과서: 'SCHOOL_PREPARE_TEXTBOOK',
    수능모의고사: 'PRACTICE_TEST_PAIR',
    시험: 'EXAM',
    수능특강: 'SAT_LECTURE',
    챌린지: 'CHALLENGE',
    자기주도학습: 'SELF_LEARNING',
    CONCEPTUAL: 'CONCEPTUAL',
    오늘의학습: 'DAILY',
  } as const

  export const TYPE_KO = {
    CUSTOM: '커스텀',
    RECOMMEND: '내신대비추천',
    PRACTICE_TEST: '모의고사',
    ARITHMETIC: '연산',
    ENTRANCE: '입학테스트',
    WEEKLY: '주간',
    CHAPTER: '단원테스트',
    SCHOOL_PREPARE_TEXTBOOK: '내신대비교과서',
    PRACTICE_TEST_PAIR: '수능모의고사',
    EXAM: '시험',
    SAT_LECTURE: '수능특강',
    CHALLENGE: '챌린지',
    SELF_LEARNING: '자기주도학습',
    CONCEPTUAL: '유형별 학습',
    DAILY: '오늘의학습',
  } as const

  export const TAG = {
    기본: 'BASIC',
    연습문제: 'PRACTICE',
    숙제: 'HOMEWORK',
    연산: 'ARITHMETIC',
    입학TEST: 'ENTRANCE_TEST',
    일일TEST: 'DAILY_TEST',
    주간TEST: 'WEEKLY_TEST',
    단원TEST: 'CHAPTER_TEST',
    총괄TEST: 'GENERAL_TEST',
    내신대비: 'SCHOOL_PREPARE',
    서술형: 'SCHOOL_PREPARE_ESSAY',
    모의고사: 'PRACTICE_TEST',
    모의고사쌍둥이: 'PRACTICE_TEST_PAIR',
    수능대비: 'CSA_TEST',
    기출유사: 'SCHOOL_TEST_PAPER',
    기타자료유사: 'CUSTOM_PAPER',
    유형별학습: 'CONCEPT_CHIP',
    유형별오답: 'CONCEPT_CHIP_WEAK_PROBLEM',
    취약유형: 'WEAK_CONCEPT_CHIP',
    그룹취약유형: 'WEAK_CONCEPT_CHIP_BY_GROUP',
    단원별취약: 'WEAK_CHAPTER',
    기간별오답: 'WEAK_DATE',
    학습지오답: 'WEAK_WORKSHEET',
    교재오답: 'WEAK_WORKBOOK',
    복습: 'REVIEW',
    기타: 'ETC',
  } as const

  export const TAG_KO = {
    BASIC: '기본',
    PRACTICE: '연습문제',
    HOMEWORK: '숙제',
    ARITHMETIC: '연산',
    ENTRANCE_TEST: '입학TEST',
    DAILY_TEST: '일일TEST',
    WEEKLY_TEST: '주간TEST',
    CHAPTER_TEST: '단원TEST',
    GENERAL_TEST: '총괄TEST',
    SCHOOL_PREPARE: '내신대비',
    SCHOOL_PREPARE_ESSAY: '내신대비 서술형',
    PRACTICE_TEST: '모의고사',
    PRACTICE_TEST_PAIR: '모의고사 쌍둥이',
    CSA_TEST: '수능대비',
    SCHOOL_TEST_PAPER: '기출 유사',
    CUSTOM_PAPER: '기타자료 유사',
    CONCEPT_CHIP: '유형별 학습',
    CONCEPT_CHIP_WEAK_PROBLEM: '유형별 오답',
    WEAK_CONCEPT_CHIP: '취약유형',
    WEAK_CONCEPT_CHIP_BY_GROUP: '그룹취약유형',
    WEAK_CHAPTER: '단원별 취약',
    WEAK_DATE: '기간별 오답',
    WEAK_WORKSHEET: '학습지 오답',
    WEAK_WORKBOOK: '교재 오답',
    REVIEW: '복습',
    ETC: '기타',
  } as const

  export const EXAM_TYPE = {
    KMM: 'KMM',
    KMM_PRACTICE_TEST: 'KMM_PRACTICE_TEST',
  } as const

  export const ACCESS_MODIFIER_TO_STUDENT = {
    PUBLIC: 'PUBLIC',
    PRIVATE: 'PRIVATE',
  } as const

  // 보충학습 타입 (무조건 학습지에 속함)
  export const SelfLearningType = S.enums(SELF_LEARNING_TYPE)
  export type SelfLearningType = S.Schema.To<typeof SelfLearningType>

  export const AccessModifierToStudent = S.enums(ACCESS_MODIFIER_TO_STUDENT)
  export const Level = S.literal(1, 2, 3, 4, 5)
  export const Type = S.enums(TYPE)
  export const Tag = S.enums(TAG)
}
